export default {
  'seivice.orderResponse': 'استجابة الطلب',
  'seivice.material': 'المواد',
  'seivice.warehouse': 'المستودع',
  'seivice.profAtersalesTeam': 'فريق بعد البيع'
}
